"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div.attrs({
    'data-component-name': 'Form.Row',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  margin: ", "px 0;\n"], ["\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  margin: ", "px 0;\n"])), function (_a) {
    var _b = _a.tight, tight = _b === void 0 ? false : _b;
    return (tight ? 8 : 16);
});
var templateObject_1;
